// 新闻模块
import * as types from 'store/mutation-types'
import Vue from 'vue'
import Stock from 'utils/stock'

const state = {
  stocks: {}
}
const getters = {
  newsRelatedStocks(state) {
    return state.stocks
  }
}
const mutations = {
  [types.UPDATE_NEWS_STOCKS](state, stocks) {
    // 如果重复，直接覆盖之前数据
    stocks.forEach(stock => {
      Vue.set(state.stocks, stock.symbol, stock)
    })
  }
}
const actions = {
  fetchBriefsBySymbols({ commit }, data) {
    Stock.getAllStockBriefs(data).then(stocks => {
      commit(types.UPDATE_NEWS_STOCKS, stocks || [])
    })
  }
}
export default { state, getters, mutations, actions }
